import { render, staticRenderFns } from "./ManageOrganization.vue?vue&type=template&id=4d9c920c"
import script from "./ManageOrganization.vue?vue&type=script&lang=js"
export * from "./ManageOrganization.vue?vue&type=script&lang=js"
import style0 from "./ManageOrganization.vue?vue&type=style&index=0&id=4d9c920c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports